import {FC, ReactNode} from "react";

interface ButtonProps {
    onClick: () => void
    name: string
    primary: boolean
    icon?: ReactNode
    disabled?: boolean
}

export const Button: FC<ButtonProps> = ({onClick, name, primary, icon, disabled=false}) => {
    if(icon){
        return <button className={primary ? disabled ? "flex-end bg-btnInfo/75 hover:outline-[#c7e5fa] hover:outline outline-1 py-3 px-6 rounded-[5px] cursor-not-allowed" : "flex-end  bg-btnInfo/75  hover:outline-[#c7e5fa] hover:outline outline-1 py-3 px-6 rounded-[5px] cursor-pointer" : disabled ? "flex-end border border-grey6 py-4 px-6 rounded-[5px] cursor-not-allowed" :  "flex-end border border-grey6 py-4 px-6 rounded-[5px] cursor-pointer"} disabled={disabled} onClick={onClick}>
            <div className="flex items-center">
                <div className="">{icon}</div>
                <div className={`ml-2 text-base font-bold ${primary ? "text-white" : ""} whitespace-nowrap`}>{name}</div>
            </div>
        </button>
    }
    return <button className={ primary ? disabled ? "flex-end border border-grey6 bg py-3 px-6 rounded-[5px] bg-btnInfo/25 cursor-not-allowed" : "flex-end py-3 px-6 m-2 rounded-[5px] bg-btnInfo hover:outline-hoverBtnInfo hover:outline outline-1 " : disabled ? "flex-end border border-grey6 py-3 px-6 m-2 bg-white rounded-[5px] cursor-not-allowed" : "flex-end border border-grey6 hover:border-grey7 py-3 px-6 m-2 bg-white rounded-[5px]"}
                   disabled={disabled} onClick={onClick}>
        <div className={ `text-base font-bold ${primary ? "text-white" : ""} whitespace-nowrap`}>{name}</div>
    </button>
}